import React from 'react';
import { navigate } from '@reach/router';

// Images
import MetaImage from '../assets/images/meta/play-with-a-friend-meta.jpg';

// Atoms
import { CenterContentWrapper, IndexPageWrapper } from '../components/Pages/index.atoms';

import { Heading } from '../components/Atoms/Heading';

// Molecules
import MetaDescription from '../components/Molecules/MetaDescription';

// Images
import vuja from '../assets/images/home/vuja.png';
import sanda from '../assets/images/home/sanda.png';
import sand from '../assets/images/home/sand.png';
import floatingDices from '../assets/images/home/floatingDices.png';
import clouds from '../assets/images/home/clouds.png';
import mobileImage from '../assets/images/home/mobileback.png';

// Atoms
import { Paragraph } from '../components/Atoms/Paragraph';
import { Flex } from '../components/Atoms/Flex-Grid';
import { Button } from '../components/Atoms/Buttons';

const IndexPage = () => (
	<>
		<MetaDescription
			page={{
				meta: {
					title: 'Online games - FatCat ArenaContext',
					metaDescription: 'Play free board like online games with friends and family.',
					ogImage: {
						src: MetaImage,
						height: 630,
						width: 1200,
					},
				},
			}}
		/>
		<IndexPageWrapper
			images={[sanda, clouds, vuja, floatingDices, sand]}
			mobileImage={mobileImage}
			cloudes={clouds}
		>
			<CenterContentWrapper padding="txl">
				<Heading padding="bm txl" scale="true">ONLINE GAMES FOR EVERY AGE</Heading>
				<Paragraph fontSize="h4" scale="true">FatCat Arena is a new gaming place perfect for everyone who wants to compete in fun games with friends and family.</Paragraph>
				<Flex justify="space-evenly" padding="tm" mobile="wrap separate_children">
					<Button
						onClick={() => navigate('/yamb')}
						size="large"
						mobile="fluid"
					>
						Play Yamb
					</Button>
					<Button
						onClick={() => navigate('/100-boxes')}
						type="outline"
						size="large"
						mobile="fluid"
					>
						Play 100 Boxes
					</Button>
				</Flex>
			</CenterContentWrapper>
		</IndexPageWrapper>
	</>
);

export default IndexPage;
